<template>
  <div class="project-flatfinder-mutate-builder">
    <FramesEditor
      v-if="$parent.active.id === 'builder'"
      :id="value.id"
      :project="project"
      :frames="frames"
      :current.sync="current"
    />

    <CustomFields
      v-model="value.customFields"
      :schema="customFieldSchemas"
      :validator="validator"
      :placement="['flatfinder:builder']"
      class="project-flatfinder-mutate-builder__sections"
    >
      <template #framesSection>
        <Frames v-model="frames" :current.sync="current" />
      </template>
    </CustomFields>
  </div>
</template>

<script>
import { i18n } from '@/i18n'

import CustomFields from '@kvass/custom-fields'
import FramesEditor from '@/components/Flatfinder/FramesEditor'
import Frames from '@/components/Flatfinder/FramesEditor/Frames'

const meta = {
  order: 1,
  id: 'builder',
  label: i18n.t('flatfinderBuilder'),
  icon: ['fal', 'file-alt'],
}

export { meta }
export default {
  props: {
    value: Object,
    project: String,
    labels: Object,
    validator: Object,
    customFieldSchemas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: 0,
    }
  },
  computed: {
    frames: {
      get() {
        return this.value.frames || []
      },
      set(frames) {
        this.$set(this.value, 'frames', frames)
      },
    },
  },

  components: {
    CustomFields,
    FramesEditor,
    Frames,
  },
}
</script>

<style lang="scss">
.project-flatfinder-mutate-builder {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  &__sections {
    .field-renderer__item {
      min-width: 0;
    }
  }
}
</style>
